import React from 'react';
import { ClockIcon } from '@heroicons/react/24/outline';

export default function TimeEstimateBadge({ minutes, className = '' }) {
  if (!minutes || minutes === 0) return null;

  const formatTime = (mins) => {
    if (mins < 60) {
      return `~${mins} min`;
    } else {
      const hours = Math.floor(mins / 60);
      const remainingMins = mins % 60;
      if (remainingMins === 0) {
        return `~${hours} ${hours === 1 ? 'hour' : 'hours'}`;
      } else {
        return `~${hours}h ${remainingMins}m`;
      }
    }
  };

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 ${className}`}>
      <ClockIcon className="h-3.5 w-3.5 mr-1" />
      {formatTime(minutes)}
    </span>
  );
}
